export const abbey = '#585A5D';
export const mountainMeadow = '#28E1A5';
export const scienceBlue = '#0069D2';
export const shark = '#2E3134';
export const shark54 = 'rgba(46, 49, 52, .54)';
export const shark80 = 'rgba(46, 49, 52, .8)';
export const solidWhite = '#FFFFFF';
export const borderGrey = '#40485d';
export const selectBorder = '#6e7482';
export const iconGrey = '#a3a7b1';
export const activityGrey24 = 'rgba(#f4f5f7, .24)';
